import { Funnel } from "lucide-react";
import {
  FunnelParamsSchema,
  defaultFunnelParams,
  type FunnelParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { FunnelWidget } from "./Component.js";

const GENERIC_SUBTITLE = "Three levels — broad to actionable";

export const funnelDef: WidgetDef<FunnelParams> = {
  kind: "funnel",
  label: "Funnel Analysis",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 352, h: 444 },
  defaultParams: defaultFunnelParams,
  Component: FunnelWidget,
  storage: "sql",
  schema: FunnelParamsSchema,
  accent: "cyan",
  icon: Funnel,
  subtitle: GENERIC_SUBTITLE,
  defaultRoster: true,
  category: "multi",
  layout: { col: 0, row: 1, width: 352, height: 420 },
  expandable: true,
  renderSubtitle: (data) => data.title?.trim() || GENERIC_SUBTITLE,
  renderFooter: (data) => {
    const totalItems = data.levels.reduce((s, l) => s + l.items.length, 0);
    return {
      left: `${data.levels.length} levels · ${totalItems} items`,
      right: "Expand to view & edit",
    };
  },
};

registerWidget(funnelDef);
